import React, {Component} from 'react';
import LoadingBox from 'components/atoms/loaders/loading-box';
import StopLineupsGeneration from 'components/molecules/stop-lineups-generation';
import {sortArrayOfObjects} from 'helpers/common-helper';
import {getFilteredLineupsByPlayer} from 'components/molecules/filter-lineups-by-player/helpers';
import {getFilteredLineupsByTeamCombinations} from 'components/molecules/filter-lineups-by-team-combinations/helpers';
import {getFilteredLineupsByCorrelationStackCombinations} from 'components/molecules/filter-lineups-by-correlation-stack-combinations/helpers';
import {getFilteredLineupsByKeyPlayerStackCombinations} from 'components/molecules/filter-lineups-by-key-player-stack-combinations/helpers';

class BaseLineupsList extends Component {
    getFilteredLineups() {
        const {
            lineups,
            filterLineupsByPlayer,
            filterLineupsByTeamCombinations,
            filterLineupsByCorrelationStackCombinations,
            filterLineupsByKeyPlayerStackCombinations,
        } = this.props;

        if (filterLineupsByPlayer.hasCheckedPlayers()) {
            return getFilteredLineupsByPlayer(lineups, filterLineupsByPlayer);
        } else if (filterLineupsByTeamCombinations.hasCheckedCombinations()) {
            return getFilteredLineupsByTeamCombinations(lineups, filterLineupsByTeamCombinations);
        } else if (filterLineupsByCorrelationStackCombinations.hasCheckedCombinations()) {
            return getFilteredLineupsByCorrelationStackCombinations(
                lineups,
                filterLineupsByCorrelationStackCombinations,
            );
        } else if (filterLineupsByKeyPlayerStackCombinations.hasCheckedCombinations()) {
            return getFilteredLineupsByKeyPlayerStackCombinations(lineups, filterLineupsByKeyPlayerStackCombinations);
        }

        return Object.values(lineups.all());
    }
    getLineupsToRender() {
        const {filters} = this.props;
        const filteredLineups = this.getFilteredLineups();

        if (isEmpty(filteredLineups)) {
            return [];
        }

        return sortArrayOfObjects(filteredLineups, filters.sort, filters.sortDirection);
    }

    getLineupsNotFoundView(params = {}) {
        const {className = 'lineup-box-empty'} = params;

        return <div className={className}>Lineups were not found.</div>;
    }

    getLineupsListView(lineups) {
        const {status} = this.props;

        return (
            <div>
                {!status.isFilled ? (
                    <LoadingBox>
                        <StopLineupsGeneration />
                    </LoadingBox>
                ) : null}
                {lineups}
            </div>
        );
    }
}

export {BaseLineupsList};
